import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=03c021f8&scoped=true&"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=03c021f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c021f8",
  null
  
)

export default component.exports